import { Injectable, ErrorHandler, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable()
export class AppErrorHandler extends ErrorHandler {
    constructor(private authService: AuthService, private router: Router, private zone: NgZone) {
        super();
    }

    handleError(error: any) {
        this.checkError(error);
        super.handleError(error);
    }

    checkError(error: any) {
        // if (error.status === 401) {
        //     this.authService.logout();
        //     this.zone.run(() => {
        //         this.authService.redirectLogoutUser();
        //     });
        // }
    }
}
